<template>
  <gap-table>
    <template #previous>
      <gap-column
        :reservation="reservation"
        type="previous"
      />
    </template>
    <template #active>
      <gap-column
        :reservation="reservation"
        type="active"
      />
    </template>
    <template #next>
      <gap-column
        :reservation="reservation"
        type="next"
      />
    </template>
  </gap-table>
</template>

<script>
import gapColumn from './gapColumn.vue'
import gapTable from './gapTable.vue'

export default {
  name: 'CArrivalTime',

  components: {
    gapColumn,
    gapTable
  },

  props: {
    reservation: Boolean
  }
}
</script>
